const Inicio = () => {
  return (
  	<section>
	  	<h1>Começar a se analisar:</h1>
		<h2>Psicanálise didática desde o início</h2>
		<img style={{ maxWidth: "70%", borderRadius: "50%"}} src="/image/beijo-lo.jpg" alt="beijo" />
	</section>
  );
};

export default Inicio;
